import { render, staticRenderFns } from "./InternalTransferForm.vue?vue&type=template&id=37c31562&scoped=true"
import script from "./InternalTransferForm.vue?vue&type=script&lang=js"
export * from "./InternalTransferForm.vue?vue&type=script&lang=js"
import style0 from "./InternalTransferForm.vue?vue&type=style&index=0&id=37c31562&prod&scoped=true&lang=css"
import style1 from "./InternalTransferForm.vue?vue&type=style&index=1&id=37c31562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c31562",
  null
  
)

export default component.exports